import React, { FC } from 'react';
import MuiRadio, { RadioProps as MuiRadioProps } from '@mui/material/Radio';
import { BpDesignSystem } from '../../types';

export type RadioProps = BpDesignSystem.PropsWithChildren<MuiRadioProps & {}>;

export const Radio: FC<RadioProps> = ({ dataTest, ...props }) => <MuiRadio data-test={dataTest} {...props} />;
